import { useEffect } from 'react';
import { useStartFlow } from './StartFlowContext';
import { useReportLoading } from './useReportLoading';

const START_FLOW_HOLD_LIMIT_MS = 20_000;

/** During the start flow, keeps the shared loading overlay up while `waiting`.
 *  Returns `true` while it does; the caller then renders nothing in place of
 *  its own loading state. A hold that lasts `START_FLOW_HOLD_LIMIT_MS` ends
 *  the flow. */
export const useStartFlowHold = (waiting: boolean): boolean => {
  const { active, end } = useStartFlow();
  const holds = active && waiting;
  useReportLoading(holds);

  useEffect(() => {
    if (!holds) return;
    const timer = setTimeout(end, START_FLOW_HOLD_LIMIT_MS);
    return () => {
      clearTimeout(timer);
    };
  }, [holds, end]);

  return holds;
};
